<template>
  <div>
    <el-dialog
      :visible="visible"
      width="20%"
      style="min-width: 350px"
      :modal="true"
      :before-close="handleClose"
      :close-on-click-modal="true">

      <div class="header-input">
        <el-autocomplete
          ref="autoComplete"
          v-model="number"
          value-key="nameNumber"
          :fetch-suggestions="suggestContacts"
          placeholder="Enter Name or Number"
          clearable
          :trigger-on-focus="false"
          @select="handleSelect"
          @clear="clearContact">
          <template slot-scope="scope">
            <contact
              v-if="!scope.item.hasOwnProperty('COMPANY') && !scope.item.hasOwnProperty('contactType')"
              :name="scope.item.name"
              :number="null"
              :email="scope.item.email"
              :status="scope.item.extStatus"
              :dnd="scope.item.dnd"
              :branch="scope.item.branch"
              :department="scope.item.department"
              :avatar="scope.item.avatarPath">
            </contact>
            <personal-contact
              v-if="scope.item.hasOwnProperty('COMPANY')"
              :firstName="scope.item.FIRSTNAME"
              :lastName="scope.item.LASTNAME"
              :number="null"
              :email="scope.item.EMAIL"
              :company="scope.item.COMPANY"
              :show-company="false">
            </personal-contact>
            <other-contact
              v-if="scope.item.hasOwnProperty('contactType')"
              class="contact-container"
              :type="scope.item.contactType"
              :name="scope.item.name"
              :number="scope.item.number"
            />
          </template>
        </el-autocomplete>
      </div>

      <div class="button-container" v-if="isTransferRequest">

        <div class="button-wrapper call-btn">
          <el-tooltip content="Blind Transfer" placement="top">
            <el-button @click="processTransfer" class="table-action-button">
              <v-svg class="voxo-green" sprite="transfer"></v-svg>
            </el-button>
          </el-tooltip>
        </div>

        <div class="button-wrapper call-btn">
          <el-tooltip content="Attended Transfer" placement="top" class="table-action-button">
            <el-button @click="processTransferAT">
              <v-svg class="voxo-aqua" sprite="call-forward"></v-svg>
            </el-button>
          </el-tooltip>
        </div>

        <div class="button-wrapper call-btn">
          <el-tooltip content="Conference" placement="top" class="table-action-button">
            <el-button @click="processTransferAT">
              <v-svg class="voxo-red" sprite="group"></v-svg>
            </el-button>
          </el-tooltip>
        </div>

        <div class="button-wrapper call-btn" v-if="userCanPark">
          <el-tooltip content="Park for user" placement="top" class="table-action-button">
            <el-button @click="processPark">
              <v-svg class="voxo-orange" sprite="call-park"></v-svg>
            </el-button>
          </el-tooltip>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import feathersClient from "@/feathers/feathers-client";
import Contact from "@/views/hudportal/contacts/components/contact";
import PersonalContact from "@/views/hudportal/contacts/components/personal-contact";
import OtherContact from "@/views/hudportal/softphone/components/other-contact";
import {globalEventBus} from "@/globalEventBus";

export default {
  name: 'Keypad',
  components: {Contact, PersonalContact, OtherContact},
  data() {
    return {
      number: '',
      selectedPerson: null,
      inputElement: null,
      currentSuggestions: [],
      transferItem: null,
      isTransferRequest: false,
      visible: false
    };
  },
  computed: {
    ...mapGetters('phonebook-entries', {getPhonebookEntries: 'find'}),
    user(){
      return this.$store.state.auth.user;
    },
    userHostServer(){
      return this.$store.state.userHostServer;
    },
    personalDirectory() {
      return this.getPhonebookEntries({
        query: {
          hasDetails: true,
          phonebookId: this.user.myExtension.omniaPhonebookId,
          $sort: {
            FIRSTNAME: 1
          }
        }
      }).data;
    },
    softphoneEnabled(){
      return this.$store.state.softphoneEnabled;
    },
    userCanPark(){
      if(this.user){
        const {myExtension} = this.user;
        if(!myExtension){
          return false;
        }
        return !!myExtension.enableParking;
      }
      return false;
    }
  },
  watch: {
    number(){
      //strip special characters
      this.number = this.number.replace(/['":/{}()[|\-.<>?_=+ \]]/g, '');
      if(!this.number.length){
        this.selectedPerson = null
      }
    },
    dialogVisible(){
      if(this.dialogVisible){
        setTimeout( () => {
          const numberField = document.getElementById('number-autocomplete').querySelector('input');
          this.inputElement = numberField;
          numberField.focus();
        }, 250);
      } else{
        this.$refs.autoComplete.suggestions = [];
        this.$store.commit('setSoftphoneTransfer', false);
        this.isTransferRequest = false;
        this.transferItem = null;
        this.clearContact();
      }
    }
  },
  methods: {
    handleClose() {
      this.isTransferRequest = false;
      this.transferItem = null;
      this.visible = false;
      this.clearContact();
    },
    updateInput(value) {
      this.number = this.number + value;
    },
    async suggestContacts(queryString, cb) {

      const searchTerm = (queryString + '').replace(/[\\"']/g, '\\$&').replace(/\u0000/g, '\\0')
      //grab all entities that can use extension dialing, not just extensions
      const directory = await feathersClient.service('extensions').find({
        query: {
          entityType: 'all',
          tenantId: this.user.myExtension.tenantId,
          $or: [
            {number: {$like: `%${searchTerm}%`}},
            {name: {$like: `%${searchTerm}%`}}
          ],
          $limit: 25
        }
      });

      let personal = queryString ? this.personalDirectory.filter(this.filterPersonal(queryString)) : this.personalDirectory;
      const results = [...directory, ...personal];
      this.currentSuggestions = results;
      this.$refs.autoComplete.highlightedIndex = 0;
      cb(results);
    },
    filterPersonal(queryString){
      return (contact) => {
        return (contact.NAME.toLowerCase().indexOf(queryString.toLowerCase()) === 0 || contact.PHONE1.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
    handleSelect(item) {
      this.selectedPerson = item;
      if(item.hasOwnProperty('PHONE1')){
        this.number = item.PHONE1;
        this.name = item.NAME;
      } else{
        this.number = item.number;
        this.name = item.name;
      }
    },
    clearContact(){
      this.number = '';
      this.name = '';
      this.selectedPerson = null
    },
    processTransfer(){
      const {sipHandle, channel, systemname, softphoneCall} = this.transferItem;

      //handle this on a desk phone
      if(!softphoneCall){
        feathersClient.service('nats-actions-handler').create({
          reqType: 'transfer',
          channel,
          ext: this.number,
          server:systemname
        });
        this.handleClose();
        return
      }

      //handle on a softphone session
      const callItem = {channel, systemname}
      globalEventBus.$emit('softphoneProcessTransfer', {sipHandle, destination: this.number, callItem});
      this.handleClose();
    },
    processTransferAT(){
      const {sipHandle, channel, systemname, softphoneCall} = this.transferItem;

      //do this for a desk phone
      if(!softphoneCall){
        feathersClient.service('nats-actions-handler').create({
          reqType: 'transferAT',
          channel: channel,
          ext: this.number,
          server:systemname
        });
        this.$store.commit('mycurrentcalls/updateItem', {channel, atxferActive: true, atxferCallerId: this.number});
        this.handleClose();
        return;
      }

      //handle on a softphone session
      const callItem = {channel, systemname};
      globalEventBus.$emit('softphoneProcessAttendedTransfer', {sipHandle, destination: this.number, callItem});
      this.$store.commit('mycurrentcalls/updateItem', {channel, atxferActive: true, atxferCallerId: this.number});
      this.handleClose();
    },
    processPark(){
      const { sipHandle, channel, systemname, cidname, cidnum, direction, peerName, softphoneCall } = this.transferItem;

      //check for user number
      if(!this.number){
        this.$notify({
          title: 'No Extension',
          message: "You must enter an extension",
          type: "error"
        });
        return;
      }

      //do this for a desk phone
      if(!softphoneCall){
        feathersClient.service('nats-actions-handler').create({
          reqType: 'softphonePark',
          channel,
          cidname,
          cidnum,
          direction,
          peerName,
          server: systemname,
          parkedFor: `${this.number}-${this.user.myExtension.tenantCode}`
        });
        this.handleClose();
        return;
      }

      //do this for a softphone session
      const callItem = {channel, systemname};
      globalEventBus.$emit('softphoneParkForUser', {sipHandle, destination: this.number, callItem});
      this.handleClose();
    }
  },
  mounted(){

    globalEventBus.$on('salesforceTransferRequest', (item) => {
      this.visible = true;
      this.isTransferRequest = true;
      this.transferItem = item;
    });

  },
  beforeDestroy(){
    globalEventBus.$off(['transferRequest']);
  }
}
</script>

<style lang="scss" scoped>

@import '../../../../../assets/scss/variables';
@import '../../../../../assets/scss/mixins';

.contact-item{
  padding: 3px 0;
  .number-details{
    margin-left: 0 !important;
  }
}

.contact-container{
  height: 40px;
}


.header-input {
  width: 85%;
  margin: 0 auto;
}

.button-container {
  text-align: center;
  padding: 12px;
  display: flex;
  justify-content: center;
}

.button-wrapper {
  margin: 10px 10px 0;
}

.el-autocomplete{
  width: 100%;
}

.contact-info {
  margin: 10px;

  .checkbox-wrapper {
    display: flex;
    justify-content: center;
  }

  .el-button {
    color: $voxo-blue;
    font-size: 15px;
  }

  ::placeholder {
    text-align: left;
    font-size: 17px;
  }

}
</style>
